import React, { useState } from "react";
import AIQueryChat from "./AIQueryChat";
import aiIcon from "../assets/WhatsApp Image 2026-07-17 at 11.29.39 PM.jpeg";

export default function AIQueryFloatingButton({ open, setOpen }) {

  return (
    <div
      className={`fixed top-0 right-0 h-full w-[450px] bg-white shadow-2xl z-50 transition-transform duration-300 ease-in-out flex flex-col ${
        open ? "translate-x-0" : "translate-x-full"
      }`}
      style={{ fontFamily: "Inter, system-ui, sans-serif" }}
    >
      {/* ── Curved Floating Tab (sticks out on the left edge of the drawer) ── */}
      <button
        onClick={() => setOpen(!open)}
        aria-label="Toggle AI Assistant"
        className="absolute left-0 bottom-12 -translate-x-full bg-white py-4 px-3 rounded-l-2xl shadow-[-6px_4px_16px_rgba(0,0,0,0.12)] border-l border-y border-gray-100 flex items-center justify-center group focus:outline-none transition-all duration-300 hover:pr-4"
        title="Luna AI Assistant"
      >
        <div className="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center shadow-md hover:scale-105 active:scale-95 transition-transform duration-200 bg-white">
          <img
            src={aiIcon}
            alt="AI Assistant"
            className="w-full h-full object-cover"
          />
        </div>
      </button>

      {/* ── Header ── */}
      <div className="bg-gradient-to-r from-blue-700 to-indigo-600 text-white p-4 flex items-center justify-between shadow-md flex-shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full overflow-hidden flex items-center justify-center bg-white flex-shrink-0 shadow-sm">
            <img src={aiIcon} alt="" className="w-full h-full object-cover" />
          </div>
          <div>
            <h3 className="font-bold text-base leading-tight">Luna AI Assistant</h3>
            <span className="text-xs text-white/80">Report Analysis & Queries</span>
          </div>
        </div>
        <button
          onClick={() => setOpen(false)}
          className="p-1.5 rounded-full hover:bg-white/10 active:bg-white/20 transition-colors text-white text-sm font-bold"
        >
          ✕
        </button>
      </div>

      {/* ── Content Body ── */}
      <div className="flex-1 min-h-0 bg-gray-50 flex flex-col">
        <AIQueryChat />
      </div>
    </div>
  );
}